/**
 * @file Overview 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect} from 'react';

import BaseCard from '~/component/BaseCard';

import './index.less';

function Overview({channelIrGs}) {
    const {contentResponseList} = channelIrGs;

    function handleClick() {}

    return (
        <div className="overview-container">
            <BaseCard title="Overview" onClick={handleClick} isConfig={false}>
                <div className="overview-content">
                    {!!contentResponseList && !!contentResponseList.length && contentResponseList[0].content.overview}
                </div>
            </BaseCard>
        </div>
    );
}

export default Overview;
